import * as React from 'react';
import LazyLoad from 'react-lazyload';
import { UitkCardContentSection } from 'uitk-react-cards';
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from 'uitk-react-images';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { classNames } from 'uitk-react-utils';
import { ImageBadges } from '../..';
import { ActivitySpannedTileCardTitle } from './activity-spanned-tile-card-title';
export var ActivitySpannedTileCardImage = function (_a) {
  var _b, _c;
  var activity = _a.activity,
    isVerticalLayout = _a.isVerticalLayout,
    isInCarousel = _a.isInCarousel,
    titleLines = _a.titleLines;
  var cardBadges = activity === null || activity === void 0 ? void 0 : activity.cardBadges;
  return React.createElement(React.Fragment, null, React.createElement(UitkLayoutPosition, {
    className: classNames({
      'uitk-flat-border-left': activity.features.pinnedTopBottom
    }),
    type: "relative"
  }, isVerticalLayout ? cardBadges && React.createElement(ImageBadges, {
    badges: cardBadges,
    isVerticalLayout: isVerticalLayout
  }) : (cardBadges === null || cardBadges === void 0 ? void 0 : cardBadges.primary) && React.createElement(ImageBadges, {
    badges: {
      primary: cardBadges.primary,
      __typename: 'ActivityCardBadges'
    },
    isVerticalLayout: isVerticalLayout
  }), React.createElement(UitkFigure, {
    ratio: isVerticalLayout ? UitkFigureAspectRatioType.R16_9 : UitkFigureAspectRatioType.R4_3
  }, React.createElement(LazyLoad, {
    height: "100%",
    offset: [100, 100],
    once: true
  }, React.createElement(UitkImage, {
    alt: (_b = activity.image) === null || _b === void 0 ? void 0 : _b.description,
    src: (_c = activity.image) === null || _c === void 0 ? void 0 : _c.url
  })))), isVerticalLayout ? React.createElement(UitkCardContentSection, null, React.createElement(ActivitySpannedTileCardTitle, {
    activity: activity,
    isInCarousel: isInCarousel,
    isVerticalLayout: isVerticalLayout,
    titleLines: titleLines
  })) : null);
};